import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import SignUp from './SignUp'
import Alert from '../components/Alert'
import { useLogInMutation } from '../RTK/ApiRequests'
import Cookies from 'js-cookie'

const SignIn = () => {

  const [isLogin, setIsLogin] = useState(true);
  const [alertText, setAlertText] = useState('')
  const [login] = useLogInMutation();

  const [loginData, setLoginData] = useState({
    email: "",
    password: ""
  })

  const handleChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value
    })
  }

  const handleClick = async (e) => {
    e.preventDefault()
    const { email, password } = loginData;

    if (!email || !password) return setAlertText("Please fill out all fields")
    else if (!email.endsWith('.com')) {
  setAlertText("Please provide an appropriate email");
    } else if (password.length < 8) {
      setAlertText("Password must be at least 8 characters long");
    } else {
      const res = await login({
        email,
        password
      })


      if (!res.data?.success) {
        if (res.error?.data) {
          setAlertText(res.error?.data?.error);
        } else {
          setAlertText('Unable To Login');
        }

      } else {
        Cookies.set('msl_ui_tok_id', res.data.token, { expires: 30 });
        window.location.href = '/'
      }
    }

  }

  useEffect(() => {
    setTimeout(() => {
      setAlertText('')
    }, 5000)  
  }, [alertText])

  return (
    <SignINWrapper>
      {
        isLogin ? <>
          <h3>Login</h3>
          <form onSubmit={handleClick}>
            <label htmlFor="email">Email</label>
            <input type="email" id='email' name="email" placeholder='Email' value={loginData.email} onChange={handleChange} />
            <label htmlFor="password">Password</label>
            <input type="password" id='password' name='password' placeholder='Password' value={loginData.password} onChange={handleChange} style={{
              marginBottom: '2rem',
            }} />
            {
              alertText !== '' ? <Alert content={alertText} /> : null  
            }
            <button type='submit'>LOGIN</button>
          </form>
          <p>OR</p>
          <button id='register' onClick={() => {
            setIsLogin(false)
          }}>REGISTER</button></> : <SignUp />
      }
    </SignINWrapper>
  )
}

const SignINWrapper = styled.section`
  height: 100vh;
  width: 50%;
  margin: 5rem auto;
  border-radius: 5px;

  h3 {
    padding: 10px;
    background-color: #494949;
    color: #fff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  
  form {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 30px 60px;
    background-color: #fff;
    border: 2px solid #C7DCDF;
    border-radius: 4px;

    label {
      cursor: pointer;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.25;
      color: #494949;
      margin-bottom: 5px;
    }

    input {
      outline: none;
      background-color: #F0F2F6;
      border: 2px solid #58678C;
      border-radius: 4px;
      padding: 10px 40px 10px 15px;
      color: #494949;
      font-size: 16px;
      display: block;
      width: 100%;
      z-index: 1;
      position: relative;
      text-transform: unset;
    }

    button {
      display: block;
      border: none;
      color: #fff;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
      text-transform: uppercase;
      margin-bottom: 0;
      background-color: #3BA61C;
      cursor: pointer;
    }
  }

  p {
    text-align: center;
    padding: 1rem;
  }

  #register {
    background-color: #58678C;
    display: block;
    border: none;
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    padding: 1rem;
    text-transform: uppercase;
    margin-bottom: 0;
    cursor: pointer;
    width: 100%;
    margin: 0 auto;
  }


  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    width: 90%;
  }

`

export default SignIn
